 <template>

   <div>
        <v-progress-linear   color="white"
                  style="margin : 0 auto; height:6px; "
                  :indeterminate="!this.dados_cadeirantes.length>0"
                  v-show="!this.dados_cadeirantes.length>0"
                ></v-progress-linear>

  <v-data-table
    :headers="headers"
    :items="this.dados_cadeirantes"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>

      <v-toolbar flat color="white">

        <v-btn to="/cadeira" class="mx-2" fab dark color="primary" v-on="on">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>

        <v-toolbar-title class="hidden-sm-and-down">
          Lista de Cadeirantes

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
        <v-btn  v-if="search"  @click="initprofdisc(search)" text icon color="green">
              <v-icon>cached</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <!--<template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">

                     <v-combobox  id="turma"
                          v-model="editedItem.turma"
                          item-value="pkturma"
                          item-text="turmadescricao"
                          :items="turmasFiltered"
                          chips
                          label="Turma"
                      ></v-combobox>
                    </v-col>

                      <v-col cols="12" sm="12" md="6">

                     <v-text-field v-if="false" id="disciplina"
                          v-model="editedItem.iddisciplina"
                          item-value="iddisciplina"

                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <template v-if="progresso">
               <div class="text-center">
                  <v-progress-circular
                    :size="50"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
               </div>
            </template>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="!replace"
                color="blue darken-1"
                :disabled="
                  btn_status
                "
                text
                @click="save"
                >Save</v-btn
              >

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon v-if="true"  small class="mr-2" @click="editItem(item)">edit</v-icon>
    </template>
    <template v-slot:no-data>
      Sem dados
    </template>
  </v-data-table>
   </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    replace: false,
    disciplinas: [],
    disciplinasFiltered: [],

    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: true,
    progresso: false,
    turmasAll: [],
    turmasFiltered: [],
    dados_cadeirantes: [],
    search: '',
    cursos: [],
    btn_status: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Código de Matricula', value: 'matricula' },
      { text: 'Disciplina', value: 'disciplina' },
      { text: 'Classe', value: 'anoacademico' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Nota da Cadeira', value: 'cadeiraNota' },
      { text: 'Nota Recurso', value: 'mfd' },
      { text: 'Fazer Cadeira na turma', value: 'idpauta' },
      { text: 'Status da cadeira', value: 'cadeiraStatus' },
      { text: 'Detalhe', value: 'action', sortable: false }
    ],

    editedIndex: -1,

    editedItem: {
      idProfessorDisciTurma: 0,
      curso: null,
      idpauta: 0,
      idturma: 0,
      disciplina: '',
      cadeiraStatus: '',
      iddisciplina: 0,
      professor: 0,
      turma: null,
      desciplinaDescricao: '',
      pkpauta: 0,
      matricula: '',
      turmaDescricao: '',
      mfd: '',
      idcadeiradefault: 0,
      cadeiraAnoqueFez: '',
      anoLectivo: '',
      autor: '',
      nome: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle () {
      return 'Inscrição na Cadeira em atraso'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dados_cadeirantes () {
      this.isLoading = false
      this.$store.state.isLoading = false
    }
  },

  created () {
    this.initializeCursos()
    this.initializeturmasAll()
    this.ListarCadeirantes()
  },

  methods: {

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ListarCadeirantes () {
      this.dados_cadeirantes = []
      let valor = this.$store.state.objturma.pkTurma
      try {
        this.dados_cadeirantes = await axios.get('/cadeira/' + valor)
          .then(res => res.data)
      } catch (erro) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async iniprofessores (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializedisciplinas () {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadDiscpilanComb (turma) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
      this.$nextTick(() => { this.editedItem.iddisciplina = undefined })
    },

    loadTurmaComb (item) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === item.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      if (item.cadeiraStatus == 'Inscrito') {
        this.btn_status = true
        this.text = 'Estudante com inscrição ja feita'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } else { this.btn_status = false }

      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.turmasFiltered = this.turmasAll.filter(t => t.idAno_Academico == item.ano_academico && t.idCurso == item.idCurso)
    },

    deleteItem (item) {
      const index = this.profediscinas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.profediscinas.splice(index, 1)
    },

    close () {
      this.replace = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save (replace) {
      this.progresso = true

      const valores =
    {
      idcadeira: 0,
      idturma: this.editedItem.turma.idTurma,
      idpauta: this.editedItem.idpauta,
      nota: null,
      autor: this.editedItem.autor,
      anodeixou: this.editedItem.anoLectivo,
      matricula: this.editedItem.matricula,
      disciplina: this.editedItem.iddisciplina,
      turmad: this.editedItem.turma.turmadescricao,
      fkpauta: this.editedItem.pkpauta,
      fkturma: this.editedItem.pkturma,
      nome_estudante: this.editedItem.nome,
      disciplina_descricao: this.editedItem.disciplina,
      turma_descricao: this.editedItem.turma.turmadescricao
    }

      // Consumindo  a api  =============Inserindo os dados
      try {
        let msg = await axios.post('/cadeiraAtrasoInsertOrUpdate', valores).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 99000 })
        this.progresso = false
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' Inscrição feita com sucesso'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          }
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } catch (error) {}
      } catch (erro) {
        console.log('erro')
      } finally {
        this.dialog = false
      }

      console.log()
    },
    async saveprof () {
      const ls = require('local-storage')
      try {
        var params = {

          idProfessorDisciTurma: this.editedItem.idProfessorDisciTurma,
          idTurma: this.editedItem.turma.descricao,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.editedItem.professor.toString().split('-')[0],
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao

        }
      } catch (error) {
        console.log('---------------------------------------------------------' + error)
      }

      try {
        let msg = await axios
          .post('/professordisciInsertOrUpdate', params)
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        let coll = {
          nome: this.editedItem.professor.toString().split('-')[1],
          descricao: this.editedItem.iddisciplina.descricao,
          turma: this.editedItem.turma.turmadescricao,
          periodo: this.editedItem.turma.periodo,
          curso: this.editedItem.turma.curso,
          anolectivo: this.editedItem.turma.anoLectivo
        }

        this.profediscinas.unshift(coll)

        this.close()
      }
    }
  }
}
</script>
